import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
    tabGroup: {
        marginBottom: theme.spacing(3),
    },
}));